import { useTranslation } from 'react-i18next'
import { useCart } from '../../contexts/CartContext'
import { useLanguage } from '../../contexts/LanguageContext'
import { formatPrice } from '../../utils/priceUtils'

const CartSummary = () => {
  const { t } = useTranslation()
  const { activeLanguage } = useLanguage()
  const { cartSummary } = useCart()

  if (!cartSummary) {
    return null
  }

  const { itemsPrice, shippingCost, totalPrice } = cartSummary

  return (
    <div>
      <div>
        <h5 style={{ display: 'inline', paddingRight: '20px' }}>
          {t('ITEMS_PRICE')}
        </h5>
        <span>{formatPrice(itemsPrice, activeLanguage)}</span>
      </div>
      <hr />
      <div>
        <h5 style={{ display: 'inline', paddingRight: '20px' }}>
          {t('SHIPPING_COST')}
        </h5>
        <span>{formatPrice(shippingCost, activeLanguage)}</span>
      </div>
      <hr />
      <div>
        <h3 style={{ display: 'inline', paddingRight: '20px' }}>
          {t('TOTAL_PRICE_WITH_SHIPPING')}
        </h3>
        <span>{formatPrice(totalPrice, activeLanguage)}</span>
      </div>
    </div>
  )
}

export default CartSummary
